import { callApi } from "../../../common/API/Api";

  export const getlang = async () => {
    try {
      let postdata = {};
      let res = await callApi(postdata, `api/get-language`);
      if (res?.data?.languages?.length) {
        return res?.data?.languages
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
